import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from 'antd';

import { useMobileDesign } from 'hooks/useMobileDesign';
import useModuleAccess from 'hooks/useModuleAccess';

import { MenuConfigWithModule } from 'types/route';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as DottedButton } from 'assets/icons/navmenu-button.svg';

import DesktopMenu from '../DesktopMenu/DesktopMenu';
import InlineMenu from '../InlineMenu/InlineMenu';
import styles from './HamburgerMenu.module.scss';

interface HamburgerMenuProps {
  items: MenuConfigWithModule[];
}

const HamburgerMenu: FC<HamburgerMenuProps> = ({ items }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const isMobile = useMobileDesign();
  const hasModuleAccess = useModuleAccess();
  const { t } = useTranslation();

  const menuItems = items.filter(
    ({ path, module }) =>
      path === '/' || Boolean(module && hasModuleAccess(module))
  );

  if (!menuItems.length) {
    return null;
  }

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  return (
    <>
      <a
        className={styles.menuButton}
        onClick={handleOpenModal}
        title={t('common.label.openMenu')}
      >
        <DottedButton />
      </a>
      <Modal
        open={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
        className={styles.container}
        width="100%"
        closeIcon={<CloseIcon />}
        destroyOnHidden
      >
        {isMobile ? (
          <InlineMenu menuItems={menuItems} onItemClick={handleCloseModal} />
        ) : (
          <DesktopMenu menuItems={menuItems} onItemClick={handleCloseModal} />
        )}
      </Modal>
    </>
  );
};

export default HamburgerMenu;
